import React from 'react';
import { useServiceClient } from 'common';
import { useMutation, useQueryClient } from 'react-query';
import { MyAppsEndPoints, MyAppsQueryKey } from './query-enums';

export const useArchiveAppQuery = (appId: string) => {
    const { postData } = useServiceClient();
    const queryClient = useQueryClient();
    const archiveApps = React.useCallback(() => postData(`${MyAppsEndPoints.ARCHIVE_APP}/${appId}/3`).then((res) => res.json()), [appId, postData]);
    return useMutation(MyAppsQueryKey.ARCHIVE_APP, archiveApps, {
        onSuccess: () => {
            queryClient.invalidateQueries(MyAppsQueryKey.GET_MY_APPS);
        }
    });
};
